import React from "react";
import LegalLayout from "./LegalLayout";
import useSeo from "@/hooks/useSeo";

export default function Gdpr() {
  useSeo({
    title: "GDPR e diritti dell'interessato",
    description: "Come esercitare i tuoi diritti GDPR (accesso, rettifica, cancellazione, portabilità) su Autofattura by Dasabo. Reclami: Garante privacy o privacy@dasabo.com.",
    path: "/gdpr",
  });
  return (
    <LegalLayout
      testid="legal-gdpr"
      kicker="Legal"
      title="Informativa GDPR &amp; diritti dell'interessato"
      updatedAt="27 febbraio 2026"
    >
      <p>
        La protezione dei tuoi dati non è un modulo da spuntare: è parte integrante di come
        progettiamo Autofattura. Qui trovi in modo sintetico come esercitare i tuoi diritti ai sensi
        del Regolamento UE 2016/679 (GDPR).
      </p>

      <h2>1. Titolare del trattamento</h2>
      <p>
        <strong>DASABO SRL</strong>, Via Imperatore Federico 100, 90143 Palermo (PA), Italia.
        P.IVA e Codice Fiscale <strong>07407380828</strong>. PEC <strong>dasabo@pec.it</strong>.
        Contatto privacy: <strong>privacy@dasabo.com</strong>.
      </p>
      <p>
        Non abbiamo l&apos;obbligo di nominare un Data Protection Officer (DPO) ex art. 37 GDPR
        poiché non svolgiamo trattamenti su larga scala di dati sensibili né monitoraggio
        sistematico di soggetti. Ci siamo dotati comunque di un <strong>referente privacy</strong>
        interno raggiungibile alla mail sopra indicata.
      </p>

      <h2>2. I tuoi diritti (artt. 15-22 GDPR)</h2>
      <ul>
        <li><strong>Accesso</strong> (art. 15) — ottenere copia dei tuoi dati personali.</li>
        <li><strong>Rettifica</strong> (art. 16) — correggere dati inesatti o incompleti.</li>
        <li><strong>Cancellazione</strong> (art. 17) — richiedere l&apos;eliminazione dei tuoi dati,
        fatti salvi gli obblighi di conservazione fiscale.</li>
        <li><strong>Limitazione</strong> (art. 18) — sospendere il trattamento in specifiche
        circostanze.</li>
        <li><strong>Opposizione</strong> (art. 21) — opporti al trattamento basato su legittimo
        interesse o marketing diretto.</li>
        <li><strong>Portabilità</strong> (art. 20) — ricevere in formato strutturato i tuoi dati
        e trasferirli a un altro titolare.</li>
        <li><strong>Revoca del consenso</strong> (art. 7 §3) — in qualsiasi momento, senza
        pregiudizio della liceità del trattamento pregresso.</li>
      </ul>

      <h2>3. Come esercitare i diritti</h2>
      <p>
        È sufficiente inviare una richiesta a <strong>privacy@dasabo.com</strong> o via PEC a
        <strong> dasabo@pec.it</strong>, allegando copia di un documento di identità in corso di
        validità (necessario per garantire che l&apos;istanza provenga effettivamente
        dall&apos;interessato). Rispondiamo entro il termine massimo di <strong>30 giorni</strong>
        prorogabile di 60 giorni per richieste complesse (art. 12 §3 GDPR).
      </p>

      <h2>4. Reclamo al Garante</h2>
      <p>
        Se ritieni che il trattamento dei tuoi dati violi il GDPR o la normativa privacy italiana,
        hai il diritto di proporre reclamo all&apos;Autorità Garante per la Protezione dei Dati
        Personali, Piazza Venezia 11, 00187 Roma, oppure via
        <a
          href="https://www.garanteprivacy.it"
          target="_blank"
          rel="noreferrer"
          className="text-[#1D4ED8] hover:underline"
        > garanteprivacy.it</a>.
      </p>

      <h2>5. Data breach</h2>
      <p>
        Nel caso di violazione dei dati personali che comporti un rischio elevato per i diritti e
        le libertà degli interessati, provvederemo a notificarti l&apos;evento senza ingiustificato
        ritardo, ai sensi degli artt. 33-34 GDPR.
      </p>

      <h2>6. Trattamento automatizzato e AI</h2>
      <p>
        Per l&apos;estrazione dei dati dai PDF caricati utilizziamo modelli AI di terze parti
        (Anthropic, OpenAI, Google). Tali modelli operano in modalità &laquo;stateless&raquo;: non
        conservano i tuoi documenti dopo l&apos;elaborazione, non li utilizzano per addestramento,
        e restituiscono esclusivamente il JSON strutturato con i dati estratti. In ogni caso, ai
        sensi dell&apos;art. 22 GDPR, ogni autofattura generata è soggetta a revisione umana
        (dell&apos;utente) prima della trasmissione allo SDI: non esiste alcuna decisione
        automatizzata unilaterale con effetti giuridici.
      </p>

      <h2>7. Sicurezza</h2>
      <ul>
        <li>Password hash con <strong>bcrypt</strong> a costo 12;</li>
        <li>JWT firmati HS256 con secret rotabile, TTL 168h;</li>
        <li>Cifratura at-rest dei token OAuth di Fatture in Cloud (Fernet);</li>
        <li>Comunicazioni cifrate TLS 1.3;</li>
        <li>Verifica firma svix sui webhook di Resend;</li>
        <li>Verifica firma OAuth Bearer su OpenAPI.it;</li>
        <li>Segregazione degli account, principio del minimo privilegio.</li>
      </ul>

      <h2>8. Consultazione</h2>
      <p>
        Per ulteriori dettagli su finalità, destinatari e trasferimenti extra-UE consulta la nostra
        <a href="/privacy" className="text-[#1D4ED8] hover:underline"> Privacy Policy </a>
        e la
        <a href="/cookies" className="text-[#1D4ED8] hover:underline"> Cookie Policy</a>.
      </p>
    </LegalLayout>
  );
}
